module.exports = __webpack_public_path__ + "static/media/channel=email.c1aa9de1.svg";